export const DEFAULT_LANG ='he' ;
export const DEFAULT_TIME_ZONE ='Asia/Jerusalem' ;
export const DEFAULT_COUNTRY = 'IL';

